import React, { useContext } from 'react';
import {useParams} from "react-router-dom";

interface CommunityContextType {
    community: string | undefined;
}

export const CommunityContext = React.createContext<CommunityContextType | undefined>(
    undefined
);

export const useCommunityContext = () => {
    const { communityId } = useParams();
    return { community:  communityId };

}
